import React from 'react';
import { View } from 'react-native';
import TouchableBounce from 'utils/packages/TouchableBounce';
import { IconClose } from 'design-system/icons/IconClose';
import Text from 'design-system/Text';
import { rem } from 'design-system/values';
import { ToastModal } from 'design-system/ToastModal';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import createStyleSheets from 'utils/createStyleSheets';
const TransactionNameCopiedToast = ({ isVisible, onClose }) => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    return (<ToastModal isVisible={isVisible} position="bottom" style={styles.modal} onCloseAction={onClose}>
      <View style={styles.toastTextContainer}>
        <Text TextThin-16 White>
          Copied transaction name
        </Text>
      </View>
      <TouchableBounce style={styles.closeIcon} onPress={onClose}>
        <IconClose alt color={colors.elements.white}/>
      </TouchableBounce>
    </ToastModal>);
};
const styleSet = createStyleSheets((colors) => ({
    modal: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: rem(100),
    },
    iconEmma: {
        marginRight: rem(12),
    },
    closeIcon: {
        marginLeft: rem(12),
        alignSelf: 'flex-start',
        backgroundColor: colors.background.transparent,
        borderRadius: rem(8),
        padding: rem(4),
    },
    toastTextContainer: {
        flex: 1,
    },
}));
export default TransactionNameCopiedToast;
